<div class="date-range-container">
    <input
        class="date-range"
        name="dateRange"
        ngbDatepicker
        #dateRange="ngbDatepicker"
        [autoClose]="'outside'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        (dateSelect)="onDateSelection($event)"
        [displayMonths]="2"
        [dayTemplate]="day"
        outsideDays="hidden"
        tabindex="0"
        (closed)="onClosed()"
    /><!-- tabindex -1 ?-->
    <ng-template #day let-date let-focused="focused">
        <span
            class="day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
        >
            {{ date.day }}
        </span>
    </ng-template>
</div>
<button class="date-range-button" [ngClass]="{ 'is-open': dateRange.isOpen() }" (click)="toggle()" type="button">
    <div class="value-container">
        <span class="label">
            {{ 'SHARED.UI.DATE_RANGE.FROM' | translate }}
            <span *ngIf="!fromDate" class="date-placeholder">{{ datePlaceholder }}</span>
            <span *ngIf="fromDate" class="date">{{ formatter.format(fromDate) }}</span>
        </span>
        <span class="label">
            {{ 'SHARED.UI.DATE_RANGE.TO' | translate }}
            <span *ngIf="!toDate" class="date-placeholder">{{ datePlaceholder }}</span>
            <span *ngIf="toDate" class="date">{{ formatter.format(toDate) }}</span>
        </span>
    </div>
    <app-icon-button *ngIf="fromDate || toDate" class="clear-button" [icon]="faXmark" (click)="clear($event)" />
    <div class="icon-container">
        <app-icon name="calendar-day" type="solid" />
    </div>
</button>
